const SecondIcon = () => {
  return (
    <svg
      width={32}
      height={32}
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Flat">
        <g id="Color">
          <polygon
            fill="#212529"
            points="8.26 3 25.94 33.62 38.06 26.62 24.42 3 8.26 3"
          />

          <path
            d="M38.06,26.62l-7.21-12.5-3.72,6.44a21.53,21.53,0,0,0-7,3l5.8,10Z"
            fill="#111315"
          />

          <polygon
            fill="#dd051d"
            points="34.6 28.62 29.4 31.62 12.87 3 19.8 3 34.6 28.62"
          />

          <polygon
            fill="#212529"
            points="39.58 3 25.94 26.62 38.06 33.62 55.74 3 39.58 3"
          />

          <path
            d="M34.6,28.62l-6.06-10.5-1.42,2.46a21.44,21.44,0,0,0-3.46,1.1l5.74,9.94Z"
            fill="#a60416"
          />

          <path
            d="M43.86,23.58a21.46,21.46,0,0,0-14.17-3.45l-3.75,6.49,12.12,7Z"
            fill="#111315"
          />

          <polygon
            fill="#dd051d"
            points="51.13 3 34.6 31.62 29.4 28.62 44.2 3 51.13 3"
          />

          <path
            d="M34.6,31.62l5.74-9.94a21.41,21.41,0,0,0-6-1.55L29.4,28.62Z"
            fill="#a60416"
          />

          <circle cx="32" cy="41.5" fill="#e3e4e5" r="19.5" />

          <circle cx="32" cy="41.5" fill="#8d9296" r="14.5" />

          <path
            d="M33.88,33.57a6.49,6.49,0,0,0-5.81,1.23,6.41,6.41,0,0,0-2.21,4.89H30c0-2.24,3.37-2.38,4-1,1,2.1-8,7-8,7v4H38v-4H34a7.07,7.07,0,0,0,4-7.54A6.16,6.16,0,0,0,33.88,33.57Z"
            fill="#FFFFFF"
          />
        </g>
      </g>
    </svg>
  );
};

export default SecondIcon;
